var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSetUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 10.25C15.636 10.25 14.125 11.761 14.125 13.625C14.125 15.489 15.636 17 17.5 17C19.364 17 20.875 15.489 20.875 13.625C20.875 11.761 19.364 10.25 17.5 10.25ZM7.5 14.625H12.2179C12.6865 17.1157 14.8732 19 17.5 19C20.4685 19 22.875 16.5935 22.875 13.625C22.875 10.6565 20.4685 8.25 17.5 8.25C14.8732 8.25 12.6865 10.1343 12.2179 12.625H7.5C6.94772 12.625 6.5 13.0727 6.5 13.625C6.5 14.1773 6.94772 14.625 7.5 14.625ZM25 12.625C24.4477 12.625 24 13.0727 24 13.625C24 14.1773 24.4477 14.625 25 14.625H32.5C33.0523 14.625 33.5 14.1773 33.5 13.625C33.5 13.0727 33.0523 12.625 32.5 12.625H25ZM27.7821 28.375C27.3135 30.8657 25.1268 32.75 22.5 32.75C19.5315 32.75 17.125 30.3435 17.125 27.375C17.125 24.4065 19.5315 22 22.5 22C25.1268 22 27.3135 23.8843 27.7821 26.375H32.5C33.0523 26.375 33.5 26.8227 33.5 27.375C33.5 27.9273 33.0523 28.375 32.5 28.375H27.7821ZM6.5 27.375C6.5 26.8227 6.94772 26.375 7.5 26.375H15C15.5523 26.375 16 26.8227 16 27.375C16 27.9273 15.5523 28.375 15 28.375H7.5C6.94772 28.375 6.5 27.9273 6.5 27.375ZM19.125 27.375C19.125 25.511 20.636 24 22.5 24C24.364 24 25.875 25.511 25.875 27.375C25.875 29.239 24.364 30.75 22.5 30.75C20.636 30.75 19.125 29.239 19.125 27.375Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUp);
export default __webpack_public_path__ + "static/media/setUp.6f83e0bc.svg";
export { ForwardRef as ReactComponent };